// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1pPkX","unreadBadge":"styles_unreadBadge__zTTns","modalContent":"styles_modalContent__2Z88S","modal":"styles_modal__1MvuC"};